import type { Currency } from '~/graphql/graphql';
import {
  shipFromFacilityChoices,
  type FacilityChoice,
} from '~/utils/facilityOptions';
import type { ProductGroup } from '~/pages/rfq-view/itemGroups';
import { itemsByPlatformProductLengthId } from '~/pages/rfq-view/sections/quoteDisplay';
import type { QuoteResponseSeed } from '~/pages/quote-response/useQuoteResponseDraft';
import type { QuoteCardQuote } from '~/pages/rfq-view/QuoteCard';

export function shipFromFacilitiesOf(quote: QuoteCardQuote): FacilityChoice[] {
  return shipFromFacilityChoices(
    quote.sellingOrganization.facilities.filter(
      (facility) => facility.locations.length > 0
    )
  );
}

export function sellerResponseSeed(
  quote: QuoteCardQuote,
  groups: ProductGroup[],
  requestForQuoteCurrency: Currency | null | undefined
): QuoteResponseSeed {
  const sellingOrganizationFacility = quote.sellingOrganizationFacility;
  return {
    groups,
    items: itemsByPlatformProductLengthId(quote.items),
    currency: quote.currency ?? requestForQuoteCurrency ?? null,
    leadTimeDays: quote.leadTimeDays ?? null,
    sellingOrganizationFacilityId: sellingOrganizationFacility
      ? sellingOrganizationFacility.id
      : null,
    wholeRequestPickupPrice: quote.offeredPickupPriceForTally ?? null,
    wholeRequestDeliveryPrice: quote.offeredDeliveryPriceForTally ?? null,
  };
}
